import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-annotation', 'open', 'Открыть аннотацию');
Labels.set('ui-annotation', 'close', 'Закрыть аннотацию');
